import React, { Component } from "react";

class SavePublishButtons extends Component {
  render() {
    const {
      hasChanges,
      title,
      content,
      status,
      onSaveDraft,
      onPublishRequest,
      cacheKey,
      theme,
      isPublished 
    } = this.props;

    const disableDraft =
      !hasChanges || title.trim().length === 0 || content.trim().length === 0;

    const disablePublish =
      title.trim().length === 0 || content.trim().length === 0;

    return (
      <div
        className="form-group mb-3 text-end"
        style={{ marginTop: "100px", paddingBottom: "30px" }}
      >
        {/* Preview current blog button */}
        <button
          type="button"
          className="btn me-2"
          disabled={!cacheKey}
          onClick={() => {
            if (cacheKey) {
              window.location.href = `/dashboard/preview?id=${cacheKey}`;
            }
          }}
          style={{
            background: "white",
            borderWidth: "1px",
            borderStyle: "dashed",
            borderColor: theme.colors.primary,
            borderRadius: "15px",
            boxShadow: theme.shadows.little,
          }}
        >
          Preview Draft
        </button>

        {/* Save as Draft button */}
        <button
          type="button"
          className="btn me-2"
          onClick={onSaveDraft}
          disabled={disableDraft}
          style={{
            background: theme.colors.secondary,
            borderWidth: "1px",
            borderStyle: "dashed",
            borderColor: theme.colors.primary,
            borderRadius: "15px",
            boxShadow: theme.shadows.little,
          }}
        >
          Save as Draft
        </button>

        {/* Publish Blog button */}
        <button
          type="button"
          className="btn"
          onClick={onPublishRequest}
          disabled={disablePublish}
          style={{
            background: theme.colors.text,
            borderRadius: "15px",
            color: theme.colors.bg,
            boxShadow: theme.shadows.standard,
          }}
        >
          {isPublished ? "Update & Publish" : "Publish Blog"}
        </button>
      </div>
    );
  }
}

export default SavePublishButtons;
